export function getLastValueMap<K, V>(prev: Map<K, V>) {
  return new Map(Array.from(prev.entries()).slice(-1));
}
